module.exports = __webpack_public_path__ + "img/nameYesOk.389359aa.png";